import { html } from 'lit-element';
import { ifDefined } from 'lit-html/directives/if-defined';

export function seoContentWrapper(seoTag, content) {
    switch (seoTag) {
        case 'h1':
            return html`
                <h1 class="seo-content-wrapper">${content}</h1>
            `;
        case 'h2':
            return html`
                <h2 class="seo-content-wrapper">${content}</h2>
            `;
        case 'h3':
            return html`
                <h3 class="seo-content-wrapper">${content}</h3>
            `;
        case 'h4':
            return html`
                <h4 class="seo-content-wrapper">${content}</h4>
            `;
        case 'h5':
            return html`
                <h5 class="seo-content-wrapper">${content}</h5>
            `;
        case 'h6':
            return html`
                <h6 class="seo-content-wrapper">${content}</h6>
            `;
        case 'span':
            return html`
                <span class="seo-content-wrapper">${content}</span>
            `;
        default:
            return html`
                <span>${content}</span>
            `;
    }
}

export const link = ({ href, target, className, clickHandler }, content) => html`
    <a
        href="${href}"
        target="${ifDefined(target)}"
        class="e2-link ${className}"
        @click="${clickHandler}"
    >
        ${content}
    </a>
`;

export const buttonLink = ({ href, className }, content) => html`
    <a href="${href}" class="${className}">
        ${content}
    </a>
`;

export const button = ({ className, disabled, clickHandler, buttonLabelClass }, content) => html`
    <button
        class="button ${className}"
        ?disabled="${disabled}"
        @click="${clickHandler}"
        type="button"
    >
        <span class="button__text ${buttonLabelClass || ''}">
            ${content}
        </span>
    </button>
`;
